export const useDefaultData = ({ Helpers }) => {

    const {
        getCurrentDate,
        getCurrentStartMonth
    } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFilterForm = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idcaja: 'ALL',
        movimiento_tipo: 'ALL'
    }

    const defaultFormScreen = {
        idoperacion: '',
        idcaja: '',
        idusuario: '',
        currency_type: '',
        fecha_operacion: getCurrentDate()
    }

    return Object.freeze({
        defaultDataModal,
        defaultFilterForm,
        defaultFormScreen
    })
}